import {
  Spacer,
  TextBase,
  Toggle,
  Tooltip,
  TooltipBubble,
} from '@carboncopyco/ui';
import { type ReactNode, useRef } from 'react';
import { EditToolBox } from '../EditToolBox';

type HoverInfoType =
  | {
      type: 'tooltipBubble';
      message: string;
    }
  | {
      type: 'tooltip';
      component: React.ReactNode;
      isVisible: boolean;
    };

export interface EditToolToggleProps {
  title: string;
  description?: string;
  onChange: (checked: boolean) => void;
  checked: boolean;
  hoverInfo?: HoverInfoType;
  disabled?: boolean;
  testId?: string;
  icon?: ReactNode;
}

export const EditToolToggle = ({
  title,
  description,
  onChange,
  checked,
  hoverInfo,
  disabled = false,
  testId,
  icon,
}: EditToolToggleProps) => {
  const anchorRef = useRef(null);

  const toggle = (
    <Toggle
      checked={checked}
      onChange={() => onChange(checked)}
      disabled={disabled}
      testId={testId}
    />
  );

  return (
    <EditToolBox>
      <div className="flex justify-between items-center w-full relative">
        <div className="flex items-center">
          {icon}
          <Spacer amount={0.4} />
          <div className="break-normal">
            <TextBase
              label={title}
              color="text-ds-natural-600"
            />
          </div>
        </div>
        <div className="ml-auto w-7">
          {hoverInfo ? (
            hoverInfo.type === 'tooltipBubble' ? (
              <TooltipBubble
                disabled={!hoverInfo.message}
                placement="top"
                title={hoverInfo.message || ''}
                offset={[0, 8]}
              >
                {toggle}
              </TooltipBubble>
            ) : (
              <>
                <div ref={anchorRef}>{toggle}</div>
                {hoverInfo.isVisible && (
                  <Tooltip
                    placement="top"
                    anchorRef={anchorRef}
                    noArrow
                  >
                    <div className="px-2 py-2.5 w-max">
                      {hoverInfo.component}
                    </div>
                  </Tooltip>
                )}
              </>
            )
          ) : (
            <>{toggle}</>
          )}
        </div>
      </div>
      {description && (
        <div className="break-normal">
          <TextBase
            label={description}
            color="text-ds-natural-300"
          />
        </div>
      )}
    </EditToolBox>
  );
};
